/*
  O formulário de produto é o do Dawn e a gaveta é a do tema de referência.
  O handler do Dawn adiciona o item mas não consegue abrir a gaveta, porque
  espera outro formato de resposta. Aqui o clique é tratado antes do Dawn:
  faz o add, redesenha a gaveta pela Section Rendering API e abre.
*/
(function () {
  if (window.__bvCartAdapter) return;
  window.__bvCartAdapter = true;

  function getDrawer() {
    var d = document.querySelector('cart-drawer');
    return d && typeof d.open === 'function' ? d : null;
  }
  function abrirGaveta() {
    var d = getDrawer();
    if (!d) return;
    d.classList.add('animate');
    void d.offsetWidth;           // o reflow entre 'animate' e 'active' é o que dispara a transição
    d.classList.add('active');
    document.body.classList.add('overflow-hidden');
    var inner = d.querySelector('.drawer__inner');
    if (inner) inner.setAttribute('aria-hidden', 'false');
  }

  function sectionId(d) {
    var w = d.closest('[id^="shopify-section"]');
    return w ? w.id.replace('shopify-section-', '') : null;
  }
  function refreshBubble(count) {
    var icon = document.querySelector('#cart-icon-bubble');
    if (!icon) return;
    var bubble = icon.querySelector('.cart-count-bubble');
    if (count > 0) {
      // a bolha não existe no HTML quando a página carregou com o carrinho vazio
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span>';
        icon.appendChild(bubble);
      }
      var sp = bubble.querySelector('span[aria-hidden]') || bubble;
      sp.textContent = count < 100 ? count : '';
    } else if (bubble) {
      bubble.remove();
    }
  }

  function redrawDrawer() {
    var d = getDrawer();
    var id = d && sectionId(d);
    if (!id) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .then(function (secs) {
        var html = secs[id];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        var current = getDrawer();
        if (!fresh || !current) return;
        // as classes do elemento dizem se a gaveta está no estado vazio; sem
        // copiá-las, o "carrinho está vazio" fica no DOM porém invisível
        var abertas = ['animate', 'active'].filter(function (k) { return current.classList.contains(k); });
        current.className = fresh.className;
        abertas.forEach(function (k) { current.classList.add(k); });
        current.innerHTML = fresh.innerHTML;
        current.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.loading = 'eager';
          var s = img.getAttribute('src');
          if (s) img.setAttribute('src', s);
        });
      });
  }

  function handle(e) {
    var btn = e.target && e.target.closest && e.target.closest('[type="submit"]');
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;
    var d = getDrawer();
    if (!d) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    btn.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status) throw new Error(json.description || json.message || 'add falhou');
        var id = sectionId(d);
        if (!id) return null;
        return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id))
          .then(function (r) { return r.json(); })
          .then(function (secs) {
            var html = secs[id];
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('cart-drawer');
            var current = getDrawer();
            if (fresh && current) {
              current.innerHTML = fresh.innerHTML;
              // o HTML injetado não passa pelo lazy-load da página, então as
              // miniaturas ficariam em branco até algum scroll acontecer
              current.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
                img.loading = 'eager';
                if (img.dataset && img.dataset.src && !img.src) img.src = img.dataset.src;
                var s = img.getAttribute('src');
                if (s) img.setAttribute('src', s);
              });
            }
          });
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (cart) refreshBubble(cart.item_count);
        var d2 = getDrawer();
        if (!d2) return;
        // a gaveta nasce vazia quando a página carrega sem itens e o open() dela
        // não reage nesse estado; aplicar o mesmo efeito que o clique no ícone produz
        abrirGaveta();
      })
      .catch(function (err) {
        if (window.console) console.warn('bv-cart-adapter:', err && err.message);
        window.location.href = '/cart';
      })
      .finally(function () { btn.classList.remove('loading'); });
  }

  document.addEventListener('click', handle, true);

  /* --------------------------------------------------------------------
     Mutações dentro da gaveta (remover item, + e - de quantidade).
     Sem isto, quem assume é o cart-items do Dawn: ele pede seções que não
     existem neste tema e mostra "Ocorreu um erro ao atualizar o carrinho",
     mesmo quando a alteração já foi gravada.
     -------------------------------------------------------------------- */

  function lineOf(el) {
    var host = el.closest('[data-index]');
    if (host && host.dataset.index) return parseInt(host.dataset.index, 10);
    var a = el.closest('a[href*="/cart/change"]');
    if (a) {
      var m = a.getAttribute('href').match(/line=(\d+)/);
      if (m) return parseInt(m[1], 10);
    }
    var item = el.closest('.cart-item, [id^="CartDrawer-Item"], [id^="CartItem"]');
    if (item) {
      var input = item.querySelector('input[data-index]');
      if (input && input.dataset.index) return parseInt(input.dataset.index, 10);
      var all = Array.prototype.slice.call(document.querySelectorAll('cart-drawer .cart-item, cart-drawer [id^="CartDrawer-Item"]'));
      var i = all.indexOf(item);
      if (i >= 0) return i + 1;
    }
    return null;
  }

  function changeLine(line, quantity) {
    var d = getDrawer();
    if (!d) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return redrawDrawer(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) { if (cart) refreshBubble(cart.item_count); })
      .catch(function (err) {
        if (window.console) console.warn('bv-cart-adapter (change):', err && err.message);
      });
  }

  document.addEventListener('click', function (e) {
    var d = getDrawer();
    if (!d || !d.contains(e.target)) return;

    var remove = e.target.closest('cart-remove-button, cart-remove-button button, a[href*="/cart/change"]');
    if (remove) {
      var l = lineOf(remove);
      if (l) { e.preventDefault(); e.stopImmediatePropagation(); changeLine(l, 0); }
      return;
    }

    var qtyBtn = e.target.closest('button[name="minus"], button[name="plus"], .quantity__button');
    if (qtyBtn) {
      var l2 = lineOf(qtyBtn);
      var input = qtyBtn.closest('quantity-input, .quantity') && qtyBtn.closest('quantity-input, .quantity').querySelector('input');
      if (l2 && input) {
        var atual = parseInt(input.value, 10) || 1;
        var nome = qtyBtn.getAttribute('name') || (qtyBtn.classList.contains('quantity__button--plus') ? 'plus' : 'minus');
        var novo = nome === 'plus' ? atual + 1 : atual - 1;
        if (novo < 0) novo = 0;
        e.preventDefault(); e.stopImmediatePropagation();
        input.value = novo;
        changeLine(l2, novo);
      }
    }
  }, true);


  document.addEventListener('click', function (e) {
    var icone = e.target.closest && e.target.closest('#cart-icon-bubble, .header__icon--cart');
    if (!icone) return;
    var d = getDrawer();
    if (!d) return;                       // sem gaveta, o link para /cart segue valendo
    e.preventDefault();
    e.stopImmediatePropagation();
    redrawDrawer().then(abrirGaveta).catch(abrirGaveta);
  }, true);
})();
